import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import Axios from "axios";

const routePrefix = "/gewichtenbl";

const GewichtenBLApi = {
    get()
    {
        const serviceUrl = prependRoot(routePrefix, getApiRoot());
		let returnValue = Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
    }
};

export default GewichtenBLApi;
